import * as angular from 'angular';
import toastr from 'toastr';

angular
  .module('screeningcanvas')
  .directive('activityTypeSelector', ['newApiClient', function (newApiClient) {
    return {
      restrict: 'A',
      scope: {
        optional: '=?',
        optionalText: '@',
      },
      template: `
        <option ng-if="optional" value="">{{ (!!optionalText) ? optionalText : "Tutte" }}</option>
        <option value="{{ item.id }}" ng-repeat="item in items">{{ item.label }}</option>
      `,
      replace: false,
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function (val) {
          return val != null ? parseInt(val, 10) : null;
        });
        ngModel.$formatters.push(function (val) {
          return val != null ? '' + val : null;
        });
      },
      controller: ['$scope', function ($scope) {
        $scope.items = [];
        newApiClient.call(`
          query {
            activityTypes {
              allActivityTypes {
                id
                label
              }
            }
          }`,
          {},
        ).then(function (data) {
          $scope.items = data.activityTypes.allActivityTypes;
        }, function () {
          toastr.error("Impossibile caricare le aree");
        });
      }],
    };
  }]);
